import { Icon } from '@iconify/react/dist/iconify.js'
import { FC, HTMLAttributes } from 'react'
import "./style.css"
import { IBaseBtn } from '../BtnTypes/Btn.type'
import { toolTipAtrributes } from 'src/utils'
import { useTranslation } from 'react-i18next'

const BaseBtn: FC<IBaseBtn> = ({ icon, ApplyAction, className, isDisabled = false, isVisible = true, label }) => {
    const { t } = useTranslation()

    if (!isVisible) return null
    return (
        <button
            {...(toolTipAtrributes(`${t(label || "")}`, "top", false))}
            className={`${className} table-action-btn pointer`} onClick={ApplyAction} disabled={isDisabled} >
            <div className='action-icon-container'>

                <Icon icon={icon} className={`table-icon`} />
            </div>
        </button>

    )
}

export default BaseBtn